<template>
  <md-card>
    <md-card-header class="md-card-header-icon md-card-header-blue">
      <div class="card-icon">
        <md-icon>text_snippet</md-icon>
      </div>
      <h4 class="title">
        Notes
      </h4>
    </md-card-header>
    <md-card-content>
      <text-editor v-model="newNoteContent" />
      <md-button
        class="md-dense md-primary"
        @click="save"
        style="margin-top: 1rem"
      >
        <md-icon>save</md-icon>
        Save
      </md-button>
    </md-card-content>
  </md-card>
</template>

<script>
import departureApi from "@/services/api/departure";
import moment from "moment";
import _filter from "lodash/filter";

export default {
  props: ["manifest", "departureId"],

  data() {
    return {};
  },

  computed: {
    newNoteContent: {
      get() {
        return this.manifest.notes;
      },
      set(newValue) {
        this.manifest.notes = newValue;
      }
    }
  },

  methods: {
    save() {
      departureApi
        .updateManifest(this.departureId, this.manifest)
        .then(response => {
          this.$emit("manifestChanged", response.data.manifest);
          this.$notify({
            timeout: 2500,
            message: "Updated.",
            icon: "thumb_up",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success"
          });
        });
    }
  }
};
</script>
<style lang="scss"></style>
